import {Directive, ElementRef, OnDestroy} from '@angular/core';
declare let vanillaTextMask: any;
@Directive({
  selector: '[appMaskDate]'
})
export class MaskDateDirective implements OnDestroy {

  mask = [/[0-3]/, /\d/, '-', /[0-1]/, /\d/, '-', /[1-2]/, /\d/, /\d/, /\d/]; // dd-mm-yyyy
  maskedInputController;

  constructor(private element: ElementRef) {
    this.maskedInputController = vanillaTextMask.maskInput({
      inputElement: this.element.nativeElement,
      mask: this.mask,
      showMask: false,
      keepCharPositions : false
    });
  }

  ngOnDestroy() {
    this.maskedInputController.destroy();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/forms/directives/mask-date.directive.ts